import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/internal/Subscription';

import { LessonStatus, Teacher } from '@df/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { AccountService } from '@app/teacher/services/account.service';

@Component({
    selector: 'app-teach-subject-list',
    templateUrl: './teach-subject-list.component.html',
    styleUrls: ['./teach-subject-list.component.scss']
})
export class TeachSubjectListComponent implements OnInit, OnDestroy {
    lesson_created = LessonStatus.LESSON_CREATED;
    teacher: Teacher;
    subjectId: number;
    classId: number;
    private routeDataSubscription: Subscription;
    private routeParamsSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private accountService: AccountService,
        private teacherService: TeacherService
    ) {}

    public ngOnInit(): void {
        this.accountService.$currentTeacher.subscribe((teacher: Teacher) => {
            this.teacher = teacher;
        });
        this.routeParamsSubscription = this.route.parent.params.subscribe(params => {
            this.subjectId = +params['subject_id'];
            this.classId = +params['class_id'];
            this.teacherService.setClassId(+params['class_id']);
            this.teacherService.setSubjectId(+params['subject_id']);
        });
    }

    public ngOnDestroy(): void {
        this.routeDataSubscription.unsubscribe();
        this.routeParamsSubscription.unsubscribe();
    }
}
